import React from "react";

const normalizeLineScore = (lineScore = [], desiredLength = 4) => {
  const scores = Array.isArray(lineScore) ? lineScore.slice(0, desiredLength) : [];
  while (scores.length < desiredLength) {
    scores.push("-");
  }
  return scores;
};

const MobileNBAScoreGrid = ({ teams, scores, t = (text) => text }) => {
  if (!teams || !scores) return null;

  const visitorLineScore = normalizeLineScore(scores?.visitors?.linescore);
  const homeLineScore = normalizeLineScore(scores?.home?.linescore);

  return (
    <div className="mt-4 pt-3 border-t border-white/10">
      <div className="grid grid-cols-[minmax(0,1.6fr)_repeat(4,minmax(0,1fr))_minmax(0,1fr)] gap-2 text-[11px] font-semibold uppercase tracking-[0.12em] text-white/60 mb-2">
        <span className="text-white/50">{t("Team")}</span>
        {[1, 2, 3, 4].map((q) => (
          <span key={`q-${q}`} className="text-center">
            {t("Q")}
            {q}
          </span>
        ))}
        <span className="text-right text-white">{t("Total")}</span>
      </div>

      <div className="space-y-2 text-sm text-white">
        <div className="grid grid-cols-[minmax(0,1.6fr)_repeat(4,minmax(0,1fr))_minmax(0,1fr)] gap-2 items-center">
          <div className="flex items-center gap-2 min-w-0">
            {teams?.visitors?.logo && (
              <img
                src={teams.visitors.logo}
                alt={teams.visitors.name}
                className="w-6 h-6 object-contain border border-white/10 rounded-sm bg-black/40"
                loading="lazy"
              />
            )}
          </div>
          {visitorLineScore.map((score, idx) => (
            <span key={`v-${idx}`} className="text-center text-base font-mono">
              {score}
            </span>
          ))}
          <span className="text-right text-base font-black tabular-nums">
            {scores?.visitors?.points ?? "-"}
          </span>
        </div>

        <div className="grid grid-cols-[minmax(0,1.6fr)_repeat(4,minmax(0,1fr))_minmax(0,1fr)] gap-2 items-center">
          <div className="flex items-center gap-2 min-w-0">
            {teams?.home?.logo && (
              <img
                src={teams.home.logo}
                alt={teams.home.name}
                className="w-6 h-6 object-contain border border-white/10 rounded-sm bg-black/40"
                loading="lazy"
              />
            )}
          </div>
          {homeLineScore.map((score, idx) => (
            <span key={`h-${idx}`} className="text-center text-base font-mono">
              {score}
            </span>
          ))}
          <span className="text-right text-base font-black tabular-nums">
            {scores?.home?.points ?? "-"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MobileNBAScoreGrid;
